import { createStyles, makeStyles, Theme } from '@material-ui/core'
import { HTMLProps, PropsWithChildren } from 'react'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    section: {
      padding: theme.spacing(1),
      [theme.breakpoints.up('sm')]: {
        padding: `${theme.spacing(6, 3)}}`,
      },
      [theme.breakpoints.up('md')]: {
        padding: `${theme.spacing(6, 6)}}`,
      },
      [theme.breakpoints.up('lg')]: {
        padding: `${theme.spacing(18, 9)}`,
      },
    },
  })
)

export const Section = (
  props: PropsWithChildren<HTMLProps<HTMLDivElement>>
) => {
  const cn = useStyles()
  const { children, className, ...rest } = props
  return (
    <div className={`${cn.section} ${className}`} {...rest}>
      {children}
    </div>
  )
}
